/**
 * This script intend to provide basic file function.
 */
import { explore } from "../../../service/API";

// Connectors
import { ProjectConnector } from "../Database/ProjectConnector";

import store from "../../store/store";

/**
 * Replace the backslash from a path with a more standard separator. (It avoids bug in SQL)
 * @param {String} path
 */
export function replaceBackSlashFromPath(path) {
  return path.split("\\").join("/");
}

/**
 * Create a new folder at path if it doesn't exist.
 * @param {String} path The path to the folder (doesn't work recursively)
 */
export function createDir(path) {
  return new Promise((resolve, reject) => {
    explore
      .post("/control/createdir/", { currPath: path })
      .then((response) => {
        if (response.status == 200) {
          return resolve();
        } else {
          return reject("create dir failed with status : " + response.status);
        }
      })
      .catch((err) => {
        console.error(err);
        return reject("create dir failed with error : " + err);
      });
  });
}

/**
 * Make an Md5 hash of a given file
 * @param {String} filepath
 * @returns File Md5 hash string
 */
export function createMd5(filepath) {
  return new Promise((resolve, reject) => {
    explore
      .post("/io/createmd5/", { currPath: filepath })
      .then((response) => {
        if (response.status == 200) {
          return resolve(response.data);
        } else {
          return reject("create md5 failed with status : " + response.status);
        }
      })
      .catch((err) => {
        console.error(err);
        return reject("create md5 failed with error : " + err);
      });
  });
}

/**
 * Extract a file to the path given in argument.
 * @param {String} zippath Path to the archive
 * @param {String} destpath Path where the archive will be extracted
 */
export function extract(zippath, destpath) {
  return new Promise((resolve, reject) => {
    explore
      .post("/io/extract/", { zipPath: zippath, destPath: destpath })
      .then((response) => {
        if (response.status == 200) {
          return resolve();
        } else {
          return reject("extract failed with status : " + response.status);
        }
      })
      .catch((err) => {
        console.error(err);
        return reject("extract failed with error : " + err);
      });
  });
}

/**
 * Give the file name without his extension and transform with underscore.
 * @param {String} filePath The path to the file
 */
export function getFileNameFromPath(filePath) {
  let fileName = "";
  if (filePath.includes(".zip")) {
    let fileNameWithExt = filePath.replace(".zip", "").split("/");
    fileNameWithExt = fileNameWithExt.join("_");
    fileName = fileNameWithExt.slice(1, fileNameWithExt.length);
  }
  return fileName;
}

/**
 * Copy a file to another path
 * @param {String} filepath
 * @param {String} newpath
 */
export function copy(filepath, newpath) {
  return new Promise((resolve, reject) => {
    explore
      .post("/control/copy/", { currPath: filepath, newPath: newpath })
      .then((response) => {
        if (response.status == 200) {
          if (filepath.indexOf(".zip") > -1) {
            //si on copy un projet, il faut créer une nouvelle entrée dans la bdd dmcvision/projet
            let projectConnector = new ProjectConnector(store.state.user);
            projectConnector.addProjectThumbnail(filepath, newpath);
          }
          return resolve();
        } else {
          return reject("copy failed with status : " + response.status);
        }
      })
      .catch((err) => {
        console.error(err);
        return reject("copy failed with error : " + err);
      });
  });
}

/**
 * Move a file to another place
 * @param {String} filepath
 * @param {String} newpath
 */
export function cut(filepath, newpath) {
  return new Promise((resolve, reject) => {
    explore
      .post("/control/move/", { currPath: filepath, newPath: newpath })
      .then((response) => {
        if (response.status == 200) {
          if (filepath.indexOf(".zip") > -1) {
            //si on cut un projet, il faut actualiser le chemin dans la bdd dmcvision/projet
            let projectConnector = new ProjectConnector(store.state.user);
            projectConnector.updateProjectPath(filepath, newpath);
          }
          return resolve();
        } else {
          return reject("cut failed with status : " + response.status);
        }
      })
      .catch((err) => {
        console.error(err);
        return reject("cut failed with error : " + err);
      });
  });
}

/**
 * Check if a file exists at 'path'
 * @param {String} path
 * @returns a boolean true or false if found or not found
 */
export function exists(path) {
  return new Promise((resolve, reject) => {
    explore
      .post("/xplore/exists/", { currPath: path })
      .then((response) => {
        // If found
        if (response.status == 200) {
          return resolve(response.data.exists);
        }
        // If not found
        else if (response.status == 404) {
          return resolve(response.data.exists);
        }
        // Everything else = error
        else {
          return reject("exists failed with status : " + response.status);
        }
      })
      .catch((err) => {
        console.error(err);
        return reject("exists failed with error : " + err);
      });
  });
}

/**
 * Read a file at the given filepath
 * @param {String} filepath
 * @returns file content
 */
export function read(filepath) {
  return new Promise((resolve, reject) => {
    explore
      .post("/io/read/", { currPath: filepath })
      .then((response) => {
        if (response.status == 200) {
          return resolve(response.data);
        } else {
          return reject("read failed with status : " + response.status);
        }
      })
      .catch((err) => {
        console.error(err);
        return reject("read failed with error : " + err);
      });
  });
}

/**
 * Remove a file at the given file path
 * @param {String} filepath
 */
export function remove(filepath) {
  return new Promise((resolve, reject) => {
    explore
      .post("/control/remove/", { currPath: filepath })
      .then((response) => {
        if (response.status == 200) {
          return resolve();
        } else {
          return reject("remove failed with status : " + response.status);
        }
      })
      .catch((err) => {
        console.error(err);
        return reject("remove failed with error : " + err);
      });
  });
}

/**
 * Rename a file at file path with the given new name
 * @param {String} filepath
 * @param {String} newname
 */
export function rename(filepath, newname) {
  return new Promise((resolve, reject) => {
    explore
      .post("/control/rename/", { currPath: filepath, newName: newname })
      .then((response) => {
        if (response.status == 200) {
          return resolve();
        } else {
          return reject("rename failed with status : " + response.status);
        }
      })
      .catch((err) => {
        console.error(err);
        return reject("rename failed with error : " + err);
      });
  });
}

/**
 * Update thumbnail of a project
 * @param {String} pid
 * @param {String} picture
 */
export function updatethumb(pid, picture, isTemplate) {
  return new Promise((resolve, reject) => {
    explore
      .post("/control/updatethumb/", {
        pid: pid,
        picture: picture,
        isTemplate: isTemplate,
      })
      .then((response) => {
        if (response.status == 200) {
          return resolve();
        } else {
          return reject("updatethumb failed with status : " + response.status);
        }
      })
      .catch((err) => {
        console.error(err);
        return reject("updatethumb failed with error : " + err);
      });
  });
}

/**
 * Copy existing thumbnail when copy a project
 * @param {String} pid
 * @param {String} newpid
 */
export function copythumb(pid, newPid) {
  return new Promise((resolve, reject) => {
    explore
      .post("/control/copythumb/", { pid: pid, newPid: newPid })
      .then((response) => {
        if (response.status == 200) {
          return resolve();
        } else {
          return reject("copythumb failed with status : " + response.status);
        }
      })
      .catch((err) => {
        console.error(err);
        return reject("copythumb failed with error : " + err);
      });
  });
}

/**
 * Delete thumbnail of a project
 * @param {String} pid
 */
export function deletethumb(pid, isTemplate = false) {
  return new Promise((resolve, reject) => {
    explore
      .post("/control/deletethumb/", { pid: pid, isTemplate: isTemplate })
      .then((response) => {
        if (response.status == 200) {
          return resolve();
        } else {
          return reject("deletethumb failed with status : " + response.status);
        }
      })
      .catch((err) => {
        console.error(err);
        return reject("deletethumb failed with error : " + err);
      });
  });
}

/**
 * Scan a given directory recursively
 * @param {String} dirpath
 * @param {Array} filter an array of string containing extension ex: [".zip"]
 * @param {Array} filelist
 * @returns an array of files and dirs
 */
export function scan(dirpath, filter, filelist) {
  return new Promise((resolve, reject) => {
    explore
      .post("/xplore/scan/", {
        currPath: dirpath,
        filter: filter,
        filelist: filelist,
      })
      .then((response) => {
        if (response.status == 200) {
          return resolve(response.data);
        } else {
          return reject("scan failed with status : " + response.status);
        }
      })
      .catch((err) => {
        console.error(err);
        return reject("scan failed with error : " + err);
      });
  });
}

/**
 * Scan a given directory without recursivity
 * @param {String} dirpath
 * @param {Array} filter an array of string containing extension ex: [".zip"]
 * @returns an array of files and dirs
 */
export function scanFlat(dirpath, filter) {
  return new Promise((resolve, reject) => {
    explore
      .post("/xplore/scanflat/", {
        currPath: dirpath,
        filter: filter,
      })
      .then((response) => {
        if (response.status == 200) {
          return resolve(response.data);
        } else {
          return reject("scan flat failed with status : " + response.status);
        }
      })
      .catch((err) => {
        console.error(err);
        return reject("scan flat failed with error : " + err);
      });
  });
}

/**
 * Scan a given directory to return a list of dirs
 * @param {String} dirpath
 * @returns an array of directories contained
 */
export function scanDir(dirpath) {
  return new Promise((resolve, reject) => {
    explore
      .post("/xplore/scandir/", { currPath: dirpath })
      .then((response) => {
        if (response.status == 200) {
          return resolve(response.data);
        } else {
          return reject("scan dir failed with status : " + response.status);
        }
      })
      .catch((err) => {
        console.error(err);
        return reject("scan dir failed with error : " + err);
      });
  });
}

/**
 * Upload a formdata containing an array of files and a destination path
 * @param {FormData} formdata
 */
export function upload(formdata) {
  return new Promise((resolve, reject) => {
    explore
      .upload("/upload/", formdata)
      .then((response) => {
        if (response.status == 200) {
          return resolve();
        } else {
          return reject("upload failed with status : " + response.status);
        }
      })
      .catch((err) => {
        console.error(err);
        return reject("upload failed with error : " + err);
      });
  });
}
